import React, { useEffect, useState, Component } from 'react';
import { Zap } from 'lucide-react';
const COOKIE_NAME = 'vvm_countdown_expiry';
const DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}
function setCookie(name: string, value: string, maxAge: number) {
  document.cookie = `${name}=${encodeURIComponent(value)};max-age=${maxAge};path=/`;
}
function getOrCreateExpiry(): number {
  const existing = getCookie(COOKIE_NAME);
  if (existing) {
    const parsed = parseInt(existing, 10);
    if (!isNaN(parsed)) return parsed;
  }
  const expiry = Date.now() + DURATION_MS;
  setCookie(COOKIE_NAME, String(expiry), 86400);
  return expiry;
}
function formatTime(ms: number): {
  hours: string;
  minutes: string;
  seconds: string;
} {
  if (ms <= 0) return {
    hours: '00',
    minutes: '00',
    seconds: '00'
  };
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}
export function StickyAlertBar() {
  const [remaining, setRemaining] = useState<number>(DURATION_MS);
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    const expiry = getOrCreateExpiry();
    const tick = () => {
      const diff = expiry - Date.now();
      if (diff <= 0) {
        setRemaining(0);
        setExpired(true);
      } else {
        setRemaining(diff);
        setExpired(false);
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const {
    hours,
    minutes,
    seconds
  } = formatTime(remaining);
  const handleClick = () => {
    const el = document.getElementById('resumen-oferta');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={handleClick} className="fixed top-0 left-0 right-0 z-50 bg-[#FF6B00] cursor-pointer select-none shadow-lg" style={{
    animation: 'bannerPulse 2s ease-in-out infinite'
  }} data-id="element-278">
      <div className="py-2 px-4 flex flex-col items-center justify-center gap-0.5" data-id="element-279">
        {/* Main headline */}
        <div className="flex items-center gap-2" data-id="element-280">
          <span className="text-white font-extrabold text-sm md:text-base uppercase tracking-wide" style={{
          textShadow: '0 1px 3px rgba(0,0,0,0.5)'
        }} data-id="element-281">
            ⚡ ESPECIAL DE HOY SOLAMENTE $17! ⚡
          </span>
        </div>

        {/* Subtext with countdown */}
        <div className="flex items-center gap-1.5 text-xs md:text-sm" style={{
        animation: 'subtextFade 2.5s ease-in-out infinite'
      }} data-id="element-282">
          {expired ? <span className="text-white font-bold" style={{
          textShadow: '0 1px 3px rgba(0,0,0,0.5)'
        }} data-id="element-283">
              ⏰ ¡Tiempo Agotado! Precio vuelve a $50
            </span> : <>
              <span className="text-white font-medium" style={{
            textShadow: '0 1px 3px rgba(0,0,0,0.5)'
          }} data-id="element-284">
                Precio Vuelve A $50 En
              </span>
              <span className="text-white font-bold" style={{
            fontVariantNumeric: 'tabular-nums',
            textShadow: '0 1px 3px rgba(0,0,0,0.5)'
          }} data-id="element-285">
                ⏰ {hours}:{minutes}:{seconds}
              </span>
            </>}
        </div>
      </div>

      <style data-id="element-286">{`
        @keyframes bannerPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.85; }
        }
        @keyframes subtextFade {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>;
}